import React from 'react';
import cnames from 'classnames';
import ReactLinkpiles from '@homeaway/react-linkpile';
import { FormattedMessage } from '../Intl';
import { connect } from 'react-redux';
import { handleEdapClick } from '../../utils/edap';
import { NEWLINKPILES_REGION_LINK_CLICK } from './events';
import './NewLinkpiles.less';

const CNAME = 'NewLinkpiles';

const handleItemLinkClick = item => (evt) => {
  handleEdapClick(NEWLINKPILES_REGION_LINK_CLICK, { lbsId: item.lbsId })(evt);
};

const NewLinkpiles = ({ linkpiles, isTouchDevice }) => (
  (linkpiles.length > 0) && (
    <div className={`row ${CNAME}__row`}>
      <div className={cnames(`${CNAME}__container`, {
        'col-xs-12': isTouchDevice,
        'col-xs-offset-1 col-xs-10': !isTouchDevice
      })}
      >
        <h2 className={`${CNAME}__title`}>
          <FormattedMessage id={'linkpiles.title'} />
        </h2>
        <ReactLinkpiles
          tabs={linkpiles}
          hideTabs={false}
          handleItemClick={handleItemLinkClick}
        />
      </div>
    </div>
  )
);

const mapStateToProps = ({
  content: { linkpiles },
  system: { isTouchDevice }
}) => ({
  linkpiles,
  isTouchDevice
});

export default connect(mapStateToProps, null)(NewLinkpiles);



// WEBPACK FOOTER //
// ./src/universal/components/Linkpiles/NewLinkpiles.js